import App from "@/components/project-finder";
import type { GetServerSideProps, GetServerSidePropsContext } from "next";
import { updateQueryFilter } from "@/redux/features/project-finder/slice";
import { wrapper } from "@/redux/store/store";
import { fetchProjects } from "@/redux/features/projects/thunk";
import EmbedsLayout from "@/components/shared/layouts/embeds/default";
import { withCommonData } from "@/hocs/with-common-data";
import type { ReactElement } from "react";
import { fetchTheme } from "@/redux/features/theme/thunk";
import { fetchHomePageRevision } from "@/redux/features/home-page-revision/thunk";

export default function Page() {
  return <App />;
}

Page.getLayout = function getLayout(page: ReactElement) {
  return <EmbedsLayout p={2}>{page}</EmbedsLayout>;
};

export const getServerSideProps: GetServerSideProps = withCommonData(
  wrapper.getServerSideProps(
    (store) => async (ctx: GetServerSidePropsContext) => {
      const config = {
        headers: {
          cookie: ctx?.req?.headers?.cookie
        }
      };
      const { baseUrl } = store.getState().adapter.adapter;

      await store.dispatch(fetchTheme({ config }));
      await store.dispatch(fetchHomePageRevision({ config }));

      store.dispatch(updateQueryFilter({ ...ctx.query, baseUrl }));

      await store.dispatch(fetchProjects({ config }));

      return {
        props: {}
      };
    }
  )
);
